import { Box } from '@mui/material';
import { dynamicWithRetry } from '../../../DynamicWithRetry';
import { ProductCardSkeletonProps } from '../ProductCard/Skeleton';
import { CategorySectionTitleSkeleton } from './CategorySectionTitleSkeleton';

const ProductCardSkeleton = dynamicWithRetry<ProductCardSkeletonProps>(
  () => import('../ProductCard/Skeleton').then(mod => ({ default: mod.ProductCardSkeleton })),
  { componentName: 'ProductCardSkeleton' },
);

type Props = {
  cardsAmount: number;
  showTitleSkeleton: boolean;
  isSeoBankingFFActive: boolean;
};

export const ProductCardCategorySectionsSkeleton = ({
  cardsAmount,
  showTitleSkeleton,
  isSeoBankingFFActive,
}: Props) => {
  return (
    <Box
      sx={{
        maxWidth: { xs: '100%', md: '82%' },
        marginX: 'auto',
        marginTop: { xs: 5, md: 8 },
        '&:first-of-type': { marginTop: 0 },
      }}
    >
      {showTitleSkeleton && <CategorySectionTitleSkeleton />}
      {Array.from({ length: cardsAmount }).map((_, index) => (
        <Box key={`card-skeleton-${index}`}>
          <ProductCardSkeleton ourTakeExpanded={isSeoBankingFFActive} />
        </Box>
      ))}
    </Box>
  );
};
